function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.84 3.10999C20.3292 2.599 19.7228 2.19364 19.0554 1.91708C18.3879 1.64052 17.6725 1.49817 16.95 1.49817C16.2275 1.49817 15.5121 1.64052 14.8446 1.91708C14.1772 2.19364 13.5708 2.599 13.06 3.10999L12 4.16999L10.94 3.10999C9.9083 2.0783 8.50903 1.4987 7.05 1.4987C5.59096 1.4987 4.19169 2.0783 3.16 3.10999C2.1283 4.14169 1.54871 5.54096 1.54871 6.99999C1.54871 8.45903 2.1283 9.8583 3.16 10.89L4.22 11.95L12 19.73L19.78 11.95L20.84 10.89C21.351 10.3792 21.7563 9.77281 22.0329 9.10535C22.3095 8.43789 22.4518 7.72248 22.4518 6.99999C22.4518 6.27751 22.3095 5.5621 22.0329 4.89464C21.7563 4.22718 21.351 3.62075 20.84 3.10999Z",
  fill: "#FF6E75",
  stroke: "#FF6E75",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFilledHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filled-heart.15318e23.svg";
export { ForwardRef as ReactComponent };